import React from 'react';
import './Team.css';
import useScrollReveal from '../hooks/useScrollReveal';

const teamMembers = [
  {
    name: 'Robin Fichter',
    role: 'Gründer & Geschäftsführer',
    image: '/images/robin-fichter.png',
    imageClass: '',
    containerClass: ''
  },
  {
    name: 'Gabriel Frank',
    role: 'Gründer & Entwicklungsleiter',
    image: '/images/gabriel-frank.png',
    imageClass: '',
    containerClass: ''
  }
];

function Team() {
  const headerRef = useScrollReveal();
  const gridRef = useScrollReveal(true);

  return (
    <section id="team" className="team">
      <div className="section-container">
        <div ref={headerRef} className="reveal">
          <h2 className="section-title">Unser Team</h2>
        </div>

        <div ref={gridRef} className="team-grid">
          {teamMembers.map((member, index) => (
            <div key={index} className="team-card" data-reveal>
              <div className={`team-image ${member.containerClass}`}>
                <img
                  src={member.image}
                  alt={member.name}
                  className={member.imageClass}
                />
              </div>
              <h3 className="team-name">{member.name}</h3>
              <p className="team-role">{member.role}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Team;
